import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import http from "@/utils/request";
Vue.prototype.http = http;
// Vue.prototype.url_img = 'http://192.168.0.99:8088'
Vue.prototype.url_img = 'https://api.yishijing.cn'
import '@/assets/css/default_name.scss';

Vue.config.productionTip = false
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')